import { render, staticRenderFns } from "./ProductSummary.vue?vue&type=template&id=a737ab28&"
import script from "./ProductSummary.vue?vue&type=script&lang=ts&"
export * from "./ProductSummary.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports